import Atendimento from "@/views/Atendimento.vue";
import Busca from "@/views/Busca.vue";
import Certificados from "@/views/Certificados.vue";
import Comprar from "@/views/Comprar.vue";
import ComprarDetalhe from "@/views/ComprarDetalhe.vue";
import Faq from "@/views/Faq.vue";
import Instalacao from "@/views/Instalacao/index.vue";
import Repositorio from "@/views/Repositorio.vue";
import Revogacao from "@/views/Revogacao.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import a1SemMidia from "./a1-sem-midia";
import a3SafeId from "./a3-safe-id";
import a3TokenOuCartao from "./a3-token-ou-cartao";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/repositorio",
		name: "Repositorio",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/repositorio",
		},
		component: Repositorio,
	},
	{
		path: "/certificados",
		name: "Certificados",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/certificados",
		},
		component: Certificados,
	},
	{
		path: "/certificados/:target",
		name: "certificado_target",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/certificados",
		},
		component: Certificados,
	},
	{
		path: "/certificados/:target/:reason",
		name: "certificado_target_reason",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/certificados",
		},
		component: Certificados,
	},
	{
		path: "/certificados/:target/:reason/:device",
		name: "certificado_target_reason_device",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/certificados",
		},
		component: Certificados,
	},
	{
		path: "/suporte/instalacao",
		name: "suporte_instalacao",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		component: Instalacao,
	},
	...a1SemMidia,
	...a3TokenOuCartao,
	...a3SafeId,
	{
		path: "/suporte/duvidas-frequentes",
		name: "suporte_duvidas_frequentes",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/duvidas-frequentes",
		},
		component: Faq,
	},
	{
		path: "/suporte/atendimento",
		name: "suporte_atendimento",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/atendimento",
		},
		component: Atendimento,
	},
	{
		path: "/suporte/revogacao",
		name: "suporte_revogacao",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/revogacao",
		},
		component: Revogacao,
	},
	{
		path: "/comprar",
		name: "comprar",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/comprar",
		},
		component: Comprar,
	},
	{
		path: "/comprar/:type",
		name: "comprar_detalhe",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/comprar",
		},
		component: ComprarDetalhe,
	},
	{
		path: "/busca/:term",
		name: "busca_resultado",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/busca",
		},
		component: Busca,
	},
	{
		path: "/*",
		name: "Home",
		redirect: "/",
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});
router.beforeEach((to, from, next) => {
	const { title, description, canonical } = to.meta;
	const defaultTitle =
		"Entenda o que é o Certificado Digital, para que serve e a importância​";
	const defaultDescription =
		"Entenda o que é um Certificado Digital, para que serve, quando ele é obrigatório, quais tipos de certificado digital existem, como adquirir e mais. Confira!​​";
	const defaultCanonical =
		"https://www.spcbrasil.com.br/certificacaodigital/";

	document.title = title || defaultTitle;

	const descriptionElement = document.querySelector(
		'head meta[name="description"]'
	);
	const canonicalElement = document.querySelector(
		'head link[rel="canonical"]'
	);

	descriptionElement.setAttribute(
		"href",
		description || defaultDescription
	);
	canonicalElement.setAttribute("content", canonical || defaultCanonical);
	return next();
});

export default router;
